module.exports = __webpack_public_path__ + "img/cu.07a0a10e.png";